module.exports = __webpack_public_path__ + "img/info-icon.11434542.svg";